import * as types from '../constants/alertActionTypes';

export const showAlert = (message, variant, options) => ({
  type: types.SHOW_ALERT,
  message,
  variant,
  options
});

export const hideAlert = () => ({ type: types.HIDE_ALERT });
